import { render, staticRenderFns } from "./PrimaryButtonAlt.vue?vue&type=template&id=16edbb90&scoped=true"
import script from "./PrimaryButtonAlt.vue?vue&type=script&lang=js"
export * from "./PrimaryButtonAlt.vue?vue&type=script&lang=js"
import style0 from "./PrimaryButtonAlt.vue?vue&type=style&index=0&id=16edbb90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16edbb90",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PrimaryButtonAlt.vue
// module id = 314
// module chunks = 0